<div class="ui-checkbox"  :class="[classStyle, state.errorStyle, state.disableStyle]">
  <input :name="name" :id="state.id"   type="checkbox" v-model="privateIsChecked" :value="value" @change="onChange(value)"
    :checked="isCheck">
  <label :for="state.id" class="checkbox-style-block" :class="{'inlineFlex': isFlex || padding, 'hoverEffect' : hoverEffect}" :style="'padding:'+[padding]"
  @keypress.enter="onClickKeypress" :tabindex=" isDisable ? -1 : 0">
    <span class="checkmark-block" >
      <span class="checkmark">
        <div class="checkitem checkmark_stem"></div>
        <div class="checkitem checkmark_kick"></div>
      </span>
    </span>
    <span class="text" >
      <template v-if="!isSlot">
        <div>
          {{text}} {{isI18n ? $t(isI18n) : ' '}}
        </div>
      </template>
      <template v-else>
        <span class="slot-content">
          <slot></slot>
        </span>
      </template>
    </span>
  </label>
</div>